// @ts-nocheck
import React, { memo, useState } from 'react';
import { Handle, Position } from 'reactflow';
import type { PDFViewerNodeProps } from '../../../types/canvas';
import './PDFViewerNode.css';

/**
 * PDF Viewer Node - 在Canvas中显示PDF文档
 */
const PDFViewerNode: React.FC<PDFViewerNodeProps> = ({ data, selected }) => {
  const content = typeof data.content === 'string'
    ? JSON.parse(data.content as unknown as string)
    : data.content;
  const { fingerprint, title, page = 1, totalPages = 1, url } = content;

  const [currentPage, setCurrentPage] = useState(page);
  const [isExpanded, setIsExpanded] = useState(false);

  const handlePrevPage = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const toggleExpand = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  const openFullPDF = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(`/?pdf=${fingerprint}`, '_blank', 'width=1200,height=900');
  };

  return (
    <div className={`pdf-viewer-node ${selected ? 'selected' : ''} ${isExpanded ? 'expanded' : ''}`}>
      <Handle type="target" position={Position.Top} />

      <div className="pdf-viewer-header">
        <div className="pdf-icon">📄</div>
        <div className="pdf-info">
          <div className="pdf-title" title={title || fingerprint}>
            {title || `PDF ${fingerprint.substring(0, 8)}...`}
          </div>
          <div className="pdf-meta">
            第 {currentPage} / {totalPages} 页
          </div>
        </div>
        <div className="pdf-actions">
          <button
            className="action-btn"
            onClick={toggleExpand}
            title={isExpanded ? "收起" : "展开"}
          >
            {isExpanded ? '⇱' : '⇲'}
          </button>
          <button
            className="action-btn"
            onClick={openFullPDF}
            title="在新窗口打开"
          >
            🗗
          </button>
        </div>
      </div>

      <div className="pdf-viewer-content">
        {isExpanded ? (
          <div className="pdf-preview-frame">
            <iframe
              src={`${url}#page=${currentPage}&view=FitH`}
              title={`PDF Page ${currentPage}`}
              className="pdf-iframe"
              sandbox="allow-same-origin allow-scripts"
            />
          </div>
        ) : (
          <div className="pdf-preview-placeholder">
            <div className="preview-icon">📖</div>
            <div className="preview-text">点击展开查看PDF</div>
            <div className="preview-hint">或直接在阅读视图中查看</div>
          </div>
        )}
      </div>

      <div className="pdf-viewer-footer">
        <div className="page-controls">
          <button
            className="page-btn"
            onClick={handlePrevPage}
            disabled={currentPage <= 1}
            title="上一页"
          >
            ←
          </button>
          <input
            type="number"
            className="page-input"
            value={currentPage}
            onChange={(e) => {
              const p = parseInt(e.target.value);
              if (p >= 1 && p <= totalPages) {
                setCurrentPage(p);
              }
            }}
            onClick={(e) => e.stopPropagation()}
            min={1}
            max={totalPages}
          />
          <button
            className="page-btn"
            onClick={handleNextPage}
            disabled={currentPage >= totalPages}
            title="下一页"
          >
            →
          </button>
        </div>
        <div className="pdf-fingerprint">
          ID: {fingerprint.substring(0, 12)}...
        </div>
      </div>

      <Handle type="source" position={Position.Bottom} />
    </div>
  );
};

export default memo(PDFViewerNode);
